import type { GetServerSidePropsContext } from 'next'

import { AUTH_BACKEND_UPSTREAM_VARIANTS } from './constants'
import { commitAuthMigrationVariant } from './with-auth-migration-experiment'

export function setAuthServerUpstreamCookie(ctx: GetServerSidePropsContext): void {
  commitAuthMigrationVariant(ctx, AUTH_BACKEND_UPSTREAM_VARIANTS.AUTH_SERVER)
}
